export default {
  "common-help": {
    helpToggleInfo: "This toggle will enable / disable part of the help info in the console. Includes any help text, links and popovers.",
    showPassword: "Show password field in clear text",
    helpFileUpload: "Upload a JSON file",
    dragHelp: "Press space or enter to begin dragging, and use the arrow keys to navigate up or down. Press enter to confirm the drag, or any other key to cancel the drag operation."
  }
};
